import { memo } from 'react';

import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';

import * as S from './style';

interface IProps {
  title?: string;
  subTitle?: string;
  priority?: boolean;
  imgSrc?: string;
  rs?: string;
  onClick?: () => void;
}

const EvtVisualBannerItem = ({
  title,
  subTitle,
  imgSrc,
  rs,
  onClick,
  priority,
}: IProps) => {
  const cName = classNameBind(['key-visual-banner-item item']);
  return (
    <S.EvtVisualBannerItem className={cName}>
      <S.ImgWrap>
        <Img
          priority={priority}
          src={getResizeImageUrl(imgSrc, rs)}
          alt={title}
        />
      </S.ImgWrap>
      <S.AreaInfo onClick={onClick}>
        <Text className="title">{title}</Text>
        <Text className="sub-title">{subTitle}</Text>
      </S.AreaInfo>
    </S.EvtVisualBannerItem>
  );
};

export default memo(EvtVisualBannerItem);
